// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/less/app_green.less
// module id = ./resources/assets/less/app_green.less
// module chunks = 0